import { createNamespacedHelpers } from 'vuex';
import { pluralize } from 'optinmonster-js-library/src/utils/strings';
const { mapActions, mapState } = createNamespacedHelpers('notifications');

export const notifications = {
	data() {
		return {
			dismissing: false,
			dismissingAll: false,
		};
	},
	computed: {
		...mapState(['alerts', 'notifications']),
		total() {
			return this.notifications.length;
		},
		hasAlerts() {
			return 0 < this.alerts.length;
		},
		hasNotifications() {
			return 0 < this.total;
		},
		title() {
			if (this.isLoading) {
				return 'Loading...';
			}
			return `(${this.total}) ${pluralize('New Notification', this.total)}`;
		},
		isLoading() {
			return this.dismissingAll || this.$store.getters.isLoading('notifications');
		},
	},
	watch: {
		total() {
			this.updateMenuBubbleCount();
		},
	},
	mounted() {
		this.updateMenuBubbleCount();
	},
	methods: {
		...mapActions(['dismiss']),
		remove(notification) {
			this.dismissing = true;
			this.dismiss(notification).finally(() => {
				this.dismissing = false;
			});
		},
		dismissAll() {
			if (this.notifications.length) {
				this.dismissingAll = true;

				this.dismiss(this.notifications).finally(() => {
					this.dismissingAll = false;
				});
			} else {
				this.$bus.$emit('notificationsToggle');
			}
		},
		getKey(notification, prefix = '') {
			const id = String(notification.id || notification.title || notification.content);
			return `${prefix}notification-${id}`;
		},
		updateMenuBubbleCount() {
			const menu = document.getElementById('toplevel_page_optin-monster-dashboard');
			const anchor = menu.querySelector('.toplevel_page_optin-monster-dashboard .wp-menu-name');
			let count = anchor.querySelector('.om-notifications-count');

			const classes = `om-notifications-count update-plugins count-${this.total}`;
			const countString = String(this.total);
			if (count) {
				count.setAttribute('class', classes);
				count.querySelector('.plugin-count').innerText = countString;
			} else {
				const fragment = document.createDocumentFragment();
				fragment.appendChild(document.createTextNode(' '));

				const inner = document.createElement('span');
				inner.classList.add('plugin-count');
				inner.appendChild(document.createTextNode(countString));

				count = document.createElement('span');
				count.setAttribute('class', classes);

				count.appendChild(inner);
				fragment.appendChild(count);
				anchor.appendChild(fragment);
			}
		},
	},
};
